import type { IconPrimitives, IconProps } from './types';

// The Kai hexagon stage-marker shape — Project_Comprehensive_ShopEdit.html's
// `.app-toolbar .stage-num` background (replaces the older plain circle).
// Figma's "Progress Stepper" pair is still named Circle-Stepper-Main-Nav-
// Outlined/Filled — a legacy name from before the hexagon swap.
const HEXAGON_PATH = 'M21.5 18L11.5 23.5L1.5 18V7L11.5 1.5L21.5 7V18Z';

export const buildHexagonIcons = ({ Svg, Path, defaultColor }: IconPrimitives) => ({
  HexagonOutlineIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d={HEXAGON_PATH} stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    </Svg>
  ),
  HexagonFilledIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d={HEXAGON_PATH} fill={color} stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    </Svg>
  ),
});
